import { render, staticRenderFns } from "./booth-representatives.vue?vue&type=template&id=faf8f6d8&scoped=true&"
import script from "./booth-representatives.vue?vue&type=script&lang=js&"
export * from "./booth-representatives.vue?vue&type=script&lang=js&"
import style0 from "./booth-representatives.vue?vue&type=style&index=0&id=faf8f6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf8f6d8",
  null
  
)

export default component.exports